import { useHistory } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { ButtonLink } from '@scouts/ui'

import { PATH_LOGIN } from '@/constants'

const Footer = () => {
    const history = useHistory()

    return <ButtonLink onClick={() => history.push(PATH_LOGIN)}>¿Ya tienes una cuenta? Inicia sesión</ButtonLink>
}
export const Signup = () => {
    return (
        <Auth.LockscreenLayout title="Empecemos por crear tu cuenta" footer={<Footer />}>
            <Auth.SignupForm />
        </Auth.LockscreenLayout>
    )
}
